<template>
  <v-sheet class="bottom-bar rounded-tl-lg rounded-tr-lg bg-white" :class="backgroundColor">
    <slot />
  </v-sheet>
</template>

<script>
export default {
  props: {
    backgroundColor: {
      default: 'green-gradient-down'
    }
  }
}
</script>

<style lang="scss" scoped>
.bottom-bar {
  position: sticky;
  bottom: 0;
}
</style>
